import { Header } from "@/components/layout/header";
import { Main } from "@/components/layout/main";
import { LogOut, BarChart2 } from "lucide-react";
import { useAuthStore } from "@/stores/auth";
import { Button } from "@/components/ui/button";
import { Outlet, Link } from "react-router-dom";

const TrackingTime: React.FC = () => {
    const { logout } = useAuthStore();
    return (
        <>
            <Header fixed className='flex justify-between w-[inherit]'>
                <div className='flex items-center space-x-4'>
                    <Link to="/tracking-time/statistics">
                        <Button variant="outline" size="icon">
                            <BarChart2 />
                        </Button>
                    </Link>
                </div>
                <div className='mr-0 flex items-center justify-end space-x-4 w-[inherit]'>
                    <Button variant="outline" size="icon" onClick={logout}>
                        <LogOut />
                    </Button>
                </div>
            </Header>

            <Main>
                <h4 className="text-xl font-semibold">Tracking Time</h4>
                <div className="flex flex-col flex-wrap w-full gap-4 mt-4">
                    <Outlet />
                </div>
            </Main>
        </>
    );
};

export default TrackingTime;
